import { createContext, ReactNode, useContext } from "react";

import { useFilterCoupon } from "./filter-coupon.hook";

const FilterCouponContext = createContext(
  {} as ReturnType<typeof useFilterCoupon>
);
export function useFilterCouponContext() {
  return useContext(FilterCouponContext);
}

interface FilterCouponProviderProps {
  children: ReactNode;
}
export function FilterCouponProvider({
  children,
}: FilterCouponProviderProps) {
  return (
    <FilterCouponContext.Provider value={useFilterCoupon()}>
      {children}
    </FilterCouponContext.Provider>
  );
}